import React from 'react'
import MyButton from './MyButton';
import PlatformIcons from './PlatformIcons';
import Logo2 from '../images/Logo2.png'
import Logo from '../images/Logo.png';
import {Link} from 'react-router-dom';

const Footer = () => {
  return (
    <div className='footer-sect '>
      <div className="footer-laptop">

        <div className="Payright-footer">
            <div className="ft-row-laptop">

    {/* Column 1 - Contact Info */}
    <div className="links-container">
      <h5>Contact Info</h5>
      <p><strong>Address:</strong><br />
        7 Raycom Road, Warri, Delta State, Nigeria
      </p>
      <p><strong>Phone/WhatsApp:</strong><br />
        07088085432
      </p>
      <p><strong>Email:</strong><br />
        subnetexpress@email.com
      </p>
      <p><strong>Office Days/Hours:</strong><br />
        Mon - Sat / 9:00 AM - 5:00 PM
      </p>
    </div>

    {/* Column 2 - About Us */}
    <div className="links-container">
      <h5>About Us</h5>
      <p>
        SubnetExpress.com is a virtual top-up platform owned and operated by SIDEN NATURE CONCEPTS TECHNOLOGIES (RC 8440373). We are duly registered with the Corporate Affairs Commission (CAC).
      </p>
      <p>
        Our services include but are not limited to buying/reselling of cheap data & airtime, electricity bills payment, cable TV subscription and airtime to cash conversion.
      </p>
      <p>
        Enjoy our massive discounts for resellers and partners and make money with us. <a href="#">Learn more</a>
      </p>
    </div>

    {/* Column 3 - Resources */}
    <div className="links-container">
      <h5>Resources</h5>
    <Link to="/dashboard">Airtime</Link>
<Link to="/dashboard">Data</Link>
<Link to="/dashboard">Cable TV</Link>
<Link to="/dashboard">Electricity</Link>
<Link to="/dashboard">Airtime to Cash</Link>
    </div>

  </div>
       

          <div className="divider"></div>
          <div className='base-footer'>
            <div className='pay-links'>
              <div className="bottom-links-container d-flex">
                <span> Copyright &copy; 2025 SubnetExpress LLC. All Rights Reserved</span>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer;
